export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/workers/module.index.worker.7eb.worker.js");
}
